import { render, staticRenderFns } from "./diySetting.vue?vue&type=template&id=216e5fcc&scoped=true"
import script from "./diySetting.vue?vue&type=script&lang=js"
export * from "./diySetting.vue?vue&type=script&lang=js"
import style0 from "./diySetting.vue?vue&type=style&index=0&id=216e5fcc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6_es6nbxkbffq4rffv33bwkugdri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216e5fcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bluetooth-light-web\\node_modules\\.pnpm\\registry.npmmirror.com+vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216e5fcc')) {
      api.createRecord('216e5fcc', component.options)
    } else {
      api.reload('216e5fcc', component.options)
    }
    module.hot.accept("./diySetting.vue?vue&type=template&id=216e5fcc&scoped=true", function () {
      api.rerender('216e5fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/neewerhome/diySetting.vue"
export default component.exports